import { useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/leads`);
      setLeads(data);
    } catch (e) {
      setLeads([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-page" className="pt-32 md:pt-40 pb-32 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between border-b border-[#E5DFD3] pb-8">
          <div>
            <p className="overline text-[#C19A6B]">Internal</p>
            <h1 className="font-serif-lux text-5xl md:text-7xl text-[#1A1A1A] tracking-tight mt-2">Leads</h1>
          </div>
          <button data-testid="admin-refresh" onClick={load} className="inline-flex items-center gap-2 border border-[#E5DFD3] px-5 py-3 overline hover:bg-[#1A1A1A] hover:text-[#FDFBF7] transition-colors">
            <RefreshCw size={15} className={loading ? "animate-spin" : ""} /> Refresh
          </button>
        </div>

        <p className="font-sans-lux text-sm text-[#5C5C5C] mt-6">{leads.length} total enquiries</p>

        <div className="mt-8 overflow-x-auto border border-[#E5DFD3]">
          <table className="w-full text-left font-sans-lux text-sm">
            <thead className="bg-[#F5F2EB] overline text-[#5C5C5C]">
              <tr>
                <th className="px-5 py-4">Date</th>
                <th className="px-5 py-4">Name</th>
                <th className="px-5 py-4">Phone</th>
                <th className="px-5 py-4">Email</th>
                <th className="px-5 py-4">Project</th>
                <th className="px-5 py-4">Message</th>
              </tr>
            </thead>
            <tbody data-testid="admin-leads-table">
              {leads.length === 0 && !loading && (
                <tr><td colSpan={6} className="px-5 py-12 text-center text-[#5C5C5C]">No leads yet.</td></tr>
              )}
              {leads.map((l) => (
                <tr key={l.id} className="border-t border-[#E5DFD3] text-[#1A1A1A] align-top">
                  <td className="px-5 py-4 whitespace-nowrap text-[#5C5C5C]">{new Date(l.created_at).toLocaleDateString()}</td>
                  <td className="px-5 py-4 whitespace-nowrap">{l.name}</td>
                  <td className="px-5 py-4 whitespace-nowrap">{l.phone}</td>
                  <td className="px-5 py-4 whitespace-nowrap">{l.email}</td>
                  <td className="px-5 py-4 whitespace-nowrap">{l.project || " - "}</td>
                  <td className="px-5 py-4 max-w-xs">{l.message || " - "}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
